<template>
  <div
    :class="classList"
    :id="id"
    tabindex="-1"
    :aria-labelled-by="ariaLabelledBy"
    :aria-hidden="!show"
    role="dialog"
    v-bind="otherAttrs"
  >
    <div :class="dialogClassList">
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    ariaLabelledBy: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList() {
      const classes = ['modal', 'fade'];
      if (this.$attrs.class) {
        const customClass = this.$attrs.class;
        if (Array.isArray(customClass)) {
          classes.push(...customClass);
        } else if (typeof customClass === 'string') {
          classes.push(customClass);
        } else if (customClass && typeof customClass === 'object') {
          // Handle object format { 'class-name': true }
          Object.keys(customClass).forEach(key => {
            if (customClass[key]) {
              classes.push(key);
            }
          });
        }
      }
      return classes;
    },
    dialogClassList() {
      const classes = ['modal-dialog'];
      if (this.size) {
        classes.push(`modal-${this.size}`);
      }
      return classes;
    },
    otherAttrs() {
      const { class: _, ...rest } = this.$attrs;
      return rest;
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const modalEl = document.getElementById(this.id);
          if (modalEl) {
            const modal = new window.bootstrap.Modal(modalEl);
            modal.show();
          }
        });
      }
    }
  }
}
</script>

